import React, { useEffect } from "react";
import { GridColumn } from "emotion-flex-grid";
import { useSelector } from "react-redux";

import HeadTitle from "components/HeadTitle";
import CollectionDisplay from "components/Collection";
import Menu from "components/Menu";
import { Container, Row, Content } from "styles/General.styled";

import cloudfront from "helpers/cloudfront";
import { useRouter } from "next/router";
import Custom404 from "../404";
import { getValidatedPageTitle } from "../../helpers/checkCollectionDirections";
import { getCollection } from "store/collectionReducer";

const Collection = () => {
  const collection = useSelector(getCollection);
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      if (!/\/collection\//.test(url)) {
        sessionStorage.removeItem("paidInCollections");
      }
    };

    router.events.on("routeChangeStart", handleRouteChange);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, []);

  if (!collection.id) {
    return <Custom404 />;
  }

  const collectionCreator = collection.collection_creator.show_business_name
    ? collection.collection_creator.business_name
    : `${collection.collection_creator.first_name} ${collection.collection_creator.last_name}`;
  const title = getValidatedPageTitle(collection.title, collectionCreator);

  return (
    <>
      <HeadTitle
        title={title}
        img={cloudfront({ href: collection.main_image, size: "medium" })}
        description={collection.description}
      />
      <Container>
        <GridColumn pt={["xl1"]} pb={["xl2", "xxl22"]}>
          <Row>
            <Menu />
            <Content>
              <CollectionDisplay collection={collection} />
            </Content>
          </Row>
        </GridColumn>
      </Container>
    </>
  );
};

export default Collection;
